<template>
    <div class="relative flex flex-col w-full h-full bg-center bg-no-repeat bg-cover rounded shadow-md select-none t3m-Card t3m-Card--flx card swiper-lazy t3m-Card--flx-sub aspect-3"
         :class="{
             't3m-Card--flx-dark': theme === 'dark',
             't3m-Card--flx-light': theme === 'light',
         }"
         :style="`background-image: url(${image})`">
        <div class="absolute inset-0 rounded"
             :class="{
                 'bg-black bg-opacity-60': theme === 'dark',
                 'bg-white bg-opacity-60': theme === 'light',
             }"></div>

        <a :href="link"
           class="relative flex-grow px-4 pt-2 lg:pt-4 no-underline card-body"
           :class="{
               'text-white': theme === 'dark',
               'text-t3m-body': theme === 'light',
           }"
           :aria-label="title">
            <h4 class="flex items-baseline mb-2 t3m-Card-title">
                <span class="t3m-u-flx-readability">{{ title }}</span>
            </h4>
        </a>

    </div>
</template>

<script>
export default {
    name: "CardSub",
    props: {
        id: String,
        title: String,
        subtitle: String,
        abstract: String,
        link: String,
        image: String,
        theme: String,
    },
};
</script>
